import type { ContentItem } from "@/content/types";

/** Delar upp "2024 – Rubrik" i årtal och rubrik. */
function splitTitle(title: string) {
  const match = title.match(/^\s*(\d{4})\s*[–-]\s*(.*)$/);
  if (match) return { year: match[1], heading: match[2] };
  return { year: "", heading: title };
}

/** Visuell tidslinje: årtal, rubrik och text per milstolpe. Inga bilder. */
export function Timeline({ items }: { items: ContentItem[] }) {
  if (items.length === 0) return null;

  return (
    <ol className="relative space-y-10 border-l border-border pl-6 sm:pl-8">
      {items.map((item) => {
        const { year, heading } = splitTitle(item.title);
        return (
          <li key={item.title} className="relative">
            <span
              aria-hidden
              className="absolute top-2 -left-[1.7rem] size-3 rounded-full bg-primary sm:-left-[2.2rem]"
            />
            {year ? (
              <p className="font-display text-2xl font-semibold text-primary">{year}</p>
            ) : null}
            <h3 className="mt-1 text-lg font-semibold">{heading}</h3>
            <p className="mt-2 max-w-2xl leading-relaxed text-muted-foreground">{item.text}</p>
          </li>
        );
      })}
    </ol>
  );
}
